import { useQuery } from '@tanstack/react-query'

import apiClient from '@/lib/api-client'
import type { BillingStatus } from '@/lib/billing-status'
import { useOrgStore } from '@/lib/store'

/** The active organization's billing status; every screen shares one cache entry. */
export function useBillingStatus({ enabled = true, staleTime }: { enabled?: boolean; staleTime?: number } = {}) {
  const activeOrgId = useOrgStore((state) => state.activeOrgId)
  return useQuery<BillingStatus>({
    queryKey: ['billing', 'status', activeOrgId],
    queryFn: async () => (await apiClient.get<BillingStatus>('/api/v1/billing/status/')).data,
    enabled: Boolean(activeOrgId) && enabled,
    staleTime,
  })
}
